import { render, staticRenderFns } from "./chinamap_effect.vue?vue&type=template&id=6fbb88f3&scoped=true&"
import script from "./chinamap_effect.vue?vue&type=script&lang=js&"
export * from "./chinamap_effect.vue?vue&type=script&lang=js&"
import style0 from "./chinamap_effect.vue?vue&type=style&index=0&id=6fbb88f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbb88f3",
  null
  
)

export default component.exports